import { render } from "./IndicadorNumero.vue?vue&type=template&id=8da8af92&scoped=true&ts=true"
import script from "./IndicadorNumero.vue?vue&type=script&lang=ts"
export * from "./IndicadorNumero.vue?vue&type=script&lang=ts"

import "./IndicadorNumero.vue?vue&type=style&index=0&id=8da8af92&scoped=true&lang=css"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8da8af92"]])

export default __exports__